import { Home, Building2, Check } from "lucide-react";
import Reveal from "./Reveal";

const PRIVATI_IMG = "/images/privati.png";
const BUSINESS_IMG = "/images/business.jpg";

const privatiPoints = [
  "Confronto e scelta della miglior offerta luce e gas",
  "Riduzione dei costi in bolletta",
  "Cambio fornitore gestito da noi, senza pensieri",
];
const businessPoints = [
  "Analisi consumi per partite IVA e aziende",
  "Forniture su misura per il tuo settore",
  "Contratti di fornitura anche in media tensione (MT)",
  "Consulente dedicato e assistenza continua",
];

function List({ points }) {
  return (
    <ul className="mt-6 space-y-3">
      {points.map((p) => (
        <li key={p} className="flex items-start gap-3">
          <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage-200">
            <Check className="h-3 w-3 text-forest-700" strokeWidth={2.5} />
          </span>
          <span className="text-base font-light text-forest-700 leading-relaxed">
            {p}
          </span>
        </li>
      ))}
    </ul>
  );
}

export default function Services() {
  return (
    <section
      id="servizi"
      data-testid="services-section"
      className="relative py-24 lg:py-32 scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-3xl">
          <span className="text-xs uppercase tracking-[0.2em] font-medium text-sage-600">
            I nostri servizi
          </span>
          <h2 className="mt-4 font-serif text-4xl md:text-5xl tracking-tight leading-tight text-forest-900">
            Una consulenza dedicata,
            <br className="hidden md:block" /> per la casa e per l'impresa.
          </h2>
        </Reveal>

        <div className="mt-16 grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Privati */}
          <Reveal className="lg:mt-0">
            <div className="overflow-hidden rounded-t-[120px] rounded-b-2xl">
              <img
                src={PRIVATI_IMG}
                alt="Famiglia a casa"
                loading="lazy"
                decoding="async"
                className="w-full h-[360px] object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
            <div className="mt-8">
              <div className="flex items-center gap-3">
                <Home className="h-5 w-5 text-sage-600" strokeWidth={1.8} />
                <h3 className="font-sans text-2xl font-medium text-forest-800">
                  Privati
                </h3>
              </div>
              <p className="mt-4 text-base font-light text-forest-700 leading-relaxed max-w-md">
                Ti aiutiamo a scegliere l'offerta luce e gas più conveniente per
                la tua famiglia, con costi chiari e nessuna sorpresa.
              </p>
              <List points={privatiPoints} />
            </div>
          </Reveal>

          {/* Business */}
          <Reveal delay={0.1} className="lg:mt-24">
            <div className="overflow-hidden rounded-2xl">
              <img
                src={BUSINESS_IMG}
                alt="Ambiente di lavoro aziendale"
                loading="lazy"
                decoding="async"
                className="w-full h-[360px] object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
            <div className="mt-8">
              <div className="flex items-center gap-3">
                <Building2 className="h-5 w-5 text-sage-600" strokeWidth={1.8} />
                <h3 className="font-sans text-2xl font-medium text-forest-800">
                  Business
                </h3>
              </div>
              <p className="mt-4 text-base font-light text-forest-700 leading-relaxed max-w-md">
                Soluzioni energetiche pensate per aziende e partite IVA, con
                analisi dei consumi e forniture ottimizzate — inclusi contratti
                di fornitura in media tensione.
              </p>
              <List points={businessPoints} />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
